import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'
import {connect} from 'react-redux'

import styles from '../styles'
import Item from '../components/item'
import actions from '../actions/item'
import rentActions from '../actions/rent'
import generalActions from '../actions/general'
import removeActions from '../../remove/actions/orchestrator'

class ItemContainer extends React.Component {

  constructor(props) {
    super(props)

    if (props.isLoggedIn === false) {
      props.history.push('/ingresar')
      return
    }

    props.fetch(props.match.params.id)
  }

  render() {
    return <Item {...this.props}/>
  }
}

ItemContainer.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  fetch: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const data = state.ui.yourItem.yourItem
  const rentData = state.ui.yourItem.rent
  const generalData = state.ui.yourItem.general
  return {
    isLoggedIn: state.domain.user.token !== '',
    isFetching: data.get('isFetching'),
    error: data.get('error'),
    item: data.get('item'),
    forRent: rentData.get('forRent'),
    price: rentData.get('price').toString(),
    isSaving: rentData.get('isFetching') || generalData.get('isFetching'),
    name: generalData.getIn(['name', 'value']),
    description: generalData.getIn(['description', 'value']),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetch: id => dispatch(actions.fetch(id)),
    startRemove: item => dispatch(removeActions.start(item)),
    setForRent: forRent => dispatch(rentActions.setForRent(forRent)),
    setPrice: price => dispatch(rentActions.setPrice(price)),
    save: () => {
      dispatch(rentActions.save())
      dispatch(generalActions.save())
    },
    setName: name => dispatch(generalActions.setName(name)),
    setDescription: description => dispatch(generalActions.setDescription(description)),
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(ItemContainer)
const Styled = compose(withStyles(styles, {withTheme: true}), withWidth())(Container)

export default Styled



// WEBPACK FOOTER //
// ./src/sections/yourItems/containers/item.js